import React from 'react';
import Radium from 'radium';
import {Container} from 'flux/utils';

import {Helmet} from "react-helmet";
import HeaderContainer from 'containers/HeaderContainer';
import CacheService from 'service/CacheService';
import AppConstants from 'AppConstants';

import {A} from 'views/AppElements';

import StockOwnerAPI from 'service/api/StockOwnerAPI';
import StockAPI from 'service/api/StockAPI';

import Footer from 'views/Footer';
import StockStore from 'stores/StockStore';
import SessionStore from 'stores/SessionStore';

import EachStockOwner from 'views/admin/EachStockOwner';

import AdminDashboardTabs from 'views/admin/AdminDashboardTabs';


const LAST_FETCHED_OWNER = "last_fetched_owner";
class StockDashboardPage extends React.Component {

    static getStores() {
        return [StockStore];
    }
    
    static calculateState(prevState, props) {
        let stockOwnerName = StockDashboardPage.getStockOwnerFromPath(props);

        if(!stockOwnerName)
            stockOwnerName = CacheService.get(LAST_FETCHED_OWNER);

        const currentSession = SessionStore.getCurrentSession();
        let newState = {
            stockOwners: StockStore.getStockOwners(),
            stockOwner: stockOwnerName? StockStore.getStockOwner(stockOwnerName): null,
            stocks: stockOwnerName? StockStore.getStocks(stockOwnerName): null,
            isAdmin: currentSession && currentSession.user.userType === AppConstants.USER_TYPE.ADMIN
        };

        return newState;
    }

    static getStockOwnerFromPath(props) {
        const stockOwner = props.match.params.stockOwner;
        return stockOwner;
    }

    componentDidMount() {
        const stockOwnerName = StockDashboardPage.getStockOwnerFromPath(this.props) || CacheService.get(LAST_FETCHED_OWNER);

        if(stockOwnerName) {
            CacheService.save(LAST_FETCHED_OWNER, stockOwnerName);
            this.fetchStockOwnerInfo(stockOwnerName);
        }

        if(this.state.stockOwners === null && this.state.isAdmin)
            StockOwnerAPI.getAllOwners();
    }

    componentWillReceiveProps(nextProps) {
        const stockOwnerName = StockDashboardPage.getStockOwnerFromPath(nextProps);

        if(stockOwnerName) {
            CacheService.save(LAST_FETCHED_OWNER, stockOwnerName);
            this.fetchStockOwnerInfo(stockOwnerName);
        }
    }

    fetchStockOwnerInfo(stockOwnerName) {
        if(!StockStore.getStockOwner(stockOwnerName)) 
            StockOwnerAPI.getStockOwner(stockOwnerName);

        if(!StockStore.getStocks(stockOwnerName))
            StockAPI.getStocks(stockOwnerName);
    }
    

    render() {
        const stockOwner = this.state.stockOwner;

        const stockOwners = this.state.stockOwners; 
        const ownerButtons = stockOwners? stockOwners.map(o => <A style={{padding: '10px', margin: '10px'}} 
                                                        href={"/stock/"+o.ownerAlias} className={(stockOwner && o.ownerAlias === stockOwner.ownerAlias)? 'active-owner': 'inactive-owner'} key={o.ownerAlias}>{o.ownerAlias}</A>): null;

        return <div id="stockDashboard">
                <Helmet>
                    <title>Inventory Dashboard | Seto Canvas</title>
                </Helmet>

                <HeaderContainer />
                
                {
                    this.state.isAdmin === true &&
                    <AdminDashboardTabs active="stocks">
                        <div className='mainContainer' style={{padding: '30px 0'}}>
                                <div className="flexRow">
                                    {ownerButtons}
                                </div>
                                {
                                    stockOwner &&
                                    <EachStockOwner stockOwner={stockOwner} stocks={this.state.stocks} allOwners={stockOwners} isAdmin={true} />
                                }

                        
                        </div>
                    </AdminDashboardTabs>
                }

                {
                    this.state.isAdmin === false &&
                    <div className='mainContainer' style={{padding: '30px 0'}}>
                        {
                            stockOwner &&
                            <EachStockOwner stockOwner={stockOwner} stocks={this.state.stocks} allOwners={stockOwners} isAdmin={false} />
                        }
                    </div>
                }
                
                

                <Footer />
        </div>
    }
}


export default Radium(Container.create(StockDashboardPage, {withProps: true}));


// WEBPACK FOOTER //
// ./src/pages/admin/StockDashboardPage.js